import React from 'react';
import { InternalAuditorTemplate } from '../components/training/templates/InternalAuditorTemplate';
import { getStandardBySlug } from '../data/standards/standardsData';
import { getInternalAuditorContent } from '../data/standards/trainingContent';

export const ISO9001InternalAuditor = () => {
  const standard = getStandardBySlug('iso-9001');
  const content = getInternalAuditorContent('iso-9001');

  return <InternalAuditorTemplate standard={standard} content={content} />;
};
